import { GroupBase, MenuListProps, components } from "react-select";
import SelectOption from "../option/select-option";
import { FC } from "react";

type SelectMenuListProps = MenuListProps<
  SelectOption,
  false,
  GroupBase<SelectOption>
> & {
  idForTesting: string | undefined;
};

const SelectMenuListComponent: FC<SelectMenuListProps> = (props) => {
  const { idForTesting, ...propsRest } = props;

  const MenuList = components.MenuList as React.ComponentType<
    MenuListProps<SelectOption, false, GroupBase<SelectOption>>
  >;

  return (
    <MenuList
      {...propsRest}
      innerProps={Object.assign({}, props.innerProps, {
        "data-test-id": idForTesting,
      })}
    />
  );
};

export default SelectMenuListComponent;
